import { createApp } from "vue/dist/vue.esm-bundler.js";
import "./style.css";

// Services
import ElementorService from "./services/ElementorService.js";
import CartService from "./services/CartService.js";
import TouchDetectionService from "./services/TouchDetectionService.js";
import WidthService from "./services/WidthService.js";
import ScrollService from "./services/ScrollService.js";
import FancyboxService from "./services/FancyboxService.js";
import JsSelectService from "./services/JsSelectService.js";
import ShowMoreService from "./services/ShowMoreService.js";
import FavoritesService from "./services/FavoritesService.js";
import NewsletterService from "./services/NewsletterService.js";
import ProductFilterService from "./services/ProductFilterService.js";
import CheckoutService from "./services/CheckoutService.js";



// Components
import KdButton from "./components/KdButton.vue";
import KdNav from "./components/KdNav.vue";
import KdNavFooter from "./components/KdNavFooter.vue";
import KdLink from "./components/KdLink.vue";
import KdFormElement from "./components/KdFormElement.vue";
import KdInput from "./components/KdInput.vue";
import KdSelect from "./components/KdSelect.vue";
import KdCheckbox from "./components/KdCheckbox.vue";
import KdAccordion from "./components/KdAccordion.vue";
import KdIcon from "./components/KdIcon.vue";
import KdInteractiveSocialSlider from "./components/KdInteractiveSocialSlider.vue";
import KdProduct from "./components/KdProduct.vue";
import KdProductCompare from "./components/KdProductCompare.vue";
import KdProductDetails from "./components/KdProductDetails.vue";
import KdProductsSlider from "./components/KdProductsSlider.vue";
import KdInteractiveSlider from "./components/KdInteractiveSlider.vue";
import KdRangeSlider from "./components/KdRangeSlider.vue";
import KdTicker from "./components/KdTicker.vue";
import KdSliderReviews from "./components/KdSliderReviews.vue";
import KdStars from "./components/KdStars.vue";
import KdStageSlider from "./components/KdStageSlider.vue";
import KdContactBox from "./components/KdContactBox.vue";
import KdCartSidebar from "./components/KdCartSidebar.vue";
import KdProductCompareSlider from "./components/KdProductCompareSlider.vue";
import KdSearch from "./components/KdSearch.vue";
import KdFavorites from "./components/KdFavorites.vue";


// Icon components
import KdIconLogo from "./components/Icon/KdLogo.vue";
import KdIconChevronDown from "./components/Icon/KdChevronDown.vue";
import KdIconHoverPoint from "./components/Icon/KdHoverPoint.vue";
import KdArrowLeft from "./components/Icon/KdArrowLeft.vue";
import KdArrowRight from "./components/Icon/KdArrowRight.vue";
import KdInstagram from "./components/Icon/KdInstagram.vue";
import KdIconHeart from "./components/Icon/KdHeart.vue";
import KdIconChevronUpDown from "./components/Icon/KdChevronUpDown.vue";
import KdIconLanguage from "./components/Icon/KdLanguage.vue";
import KdIconCart from "./components/Icon/KdCart.vue";
import KdIconCartPlus from "./components/Icon/KdCartPlus.vue";
import KdIconZoom from "./components/Icon/KdZoom.vue";
import KdIconTrash from "./components/Icon/KdTrash.vue";
import KdIconPlus from "./components/Icon/KdPlus.vue";
import KdIconMinus from "./components/Icon/KdMinus.vue";
import KdIconSearch from "./components/Icon/KdSearch.vue";
import KdIconPerson from "./components/Icon/KdPerson.vue";
import KdIconX from "./components/Icon/KdX.vue";
import KdIconFacebook from "./components/Icon/KdFacebook.vue";
import KdIconYoutube from "./components/Icon/KdYoutube.vue";
import KdIconPaypal from "./components/Icon/KdPaypal.vue";
import KdIconMastercard from "./components/Icon/KdMastercard.vue";
import KdIconVisa from "./components/Icon/KdVisa.vue";
import KdIconStar from "./components/Icon/KdStar.vue";
import KdIconPackage from "./components/Icon/KdPackage.vue";
import KdIconDelivery from "./components/Icon/KdDelivery.vue";
import KdIconMail from "./components/Icon/KdMail.vue";
import KdIconPhone from "./components/Icon/KdPhone.vue";
import KdIconCheckmark from "./components/Icon/KdCheckmark.vue";
import KdIconLoading from "./components/Icon/KdLoading.vue";

// Modules
import KdSlider from "./modules/KdSlider.vue";


const components = [
    { name: "kd-button", component: KdButton },
    { name: "kd-nav", component: KdNav },
    { name: "kd-nav-footer", component: KdNavFooter },
    { name: "kd-link", component: KdLink },
    { name: "kd-form-element", component: KdFormElement },
    { name: "kd-input", component: KdInput },
    { name: "kd-select", component: KdSelect },
    { name: "kd-checkbox", component: KdCheckbox },
    { name: "kd-accordion", component: KdAccordion },
    { name: "kd-icon", component: KdIcon },
    { name: "kd-slider", component: KdSlider },
    { name: "kd-interactive-social-slider", component: KdInteractiveSocialSlider },
    { name: "kd-product", component: KdProduct },
    { name: "kd-product-compare", component: KdProductCompare },
    { name: "kd-product-details", component: KdProductDetails },
    { name: "kd-product-slider", component: KdProductsSlider },
    { name: "kd-interactive-slider", component: KdInteractiveSlider },
    { name: "kd-range-slider", component: KdRangeSlider },
    { name: "kd-ticker", component: KdTicker },
    { name: "kd-review-slider", component: KdSliderReviews },
    { name: "kd-stars", component: KdStars },
    { name: "kd-stage-slider", component: KdStageSlider },
    { name: "kd-contact-box", component: KdContactBox },
    { name: "kd-cart-sidebar", component: KdCartSidebar },
    { name: "kd-product-compare-slider", component: KdProductCompareSlider },
    { name: "kd-search", component: KdSearch },
    { name: "kd-favorites", component: KdFavorites },

];

const icons = [
    { name: "kd-icon-logo", component: KdIconLogo},
    { name: "kd-icon-chevron-down", component: KdIconChevronDown },
    { name: "kd-icon-arrow-left", component: KdArrowLeft },
    { name: "kd-icon-arrow-right", component: KdArrowRight },
    { name: "kd-icon-instagram", component: KdInstagram },
    { name: "kd-icon-chevron-up-down", component: KdIconChevronUpDown },
    { name: "kd-icon-heart", component: KdIconHeart },
    { name: "kd-icon-language", component: KdIconLanguage },
    { name: "kd-icon-cart", component: KdIconCart },
    { name: "kd-icon-cart-plus", component: KdIconCartPlus },
    { name: "kd-icon-zoom", component: KdIconZoom },
    { name: "kd-icon-trash", component: KdIconTrash },
    { name: "kd-icon-plus", component: KdIconPlus },
    { name: "kd-icon-minus", component: KdIconMinus },
    { name: "kd-icon-search", component: KdIconSearch },
    { name: "kd-icon-hover-point", component: KdIconHoverPoint },
    { name: "kd-icon-person", component: KdIconPerson },
    { name: "kd-icon-x", component: KdIconX },
    { name: "kd-icon-facebook", component: KdIconFacebook },
    { name: "kd-icon-youtube", component: KdIconYoutube },
    { name: "kd-icon-paypal", component: KdIconPaypal },
    { name: "kd-icon-mastercard", component: KdIconMastercard },
    { name: "kd-icon-visa", component: KdIconVisa },
    { name: "kd-icon-star", component: KdIconStar },
    { name: "kd-icon-package", component: KdIconPackage },
    { name: "kd-icon-delivery", component: KdIconDelivery },
    { name: "kd-icon-mail", component: KdIconMail },
    { name: "kd-icon-phone", component: KdIconPhone },
    { name: "kd-icon-checkmark", component: KdIconCheckmark },
    { name: "kd-icon-loading", component: KdIconLoading },

];

const app = createApp({});

const regComponents = (instance) => {
    components.forEach(({ name, component }) => {
        instance.component(name, component);
    });

    icons.forEach(({ name, component }) => {
        instance.component(name, component);
    });
};

regComponents(app);
app.mount("#app");
new ElementorService((widget) => {
    regComponents(widget);
});
new FavoritesService();
new TouchDetectionService();
new WidthService();
new FancyboxService();
new JsSelectService();
new ShowMoreService();
new NewsletterService();
new ProductFilterService();
new CheckoutService();

// woocommerce
const cartService = new CartService();
cartService.initShippingShow();
cartService.initAjaxAddToCart(".js-add-to-cart-form");
cartService.initAjaxCoupons();
cartService.initDonationBox();
cartService.initCartQuantityControls();
window.kdCartService = cartService;

/* global jQuery */
// After WooCommerce reloads shipping/cart via its own AJAX, rebind coupon + shipping
if (window.jQuery) {
    jQuery(document.body).on("updated_cart_totals updated_wc_div", () => {
        cartService.initAjaxCoupons();
        cartService.initShippingShow();
        cartService.initDonationBox();
    });
}

// scrolling
const scrollService = new ScrollService();
scrollService.init();
